import React from 'react'
import { confirmDeleteData } from './helper'

function DeleteModal({setShowDeleteModal,todelete,isLoading,setIsLoading,settoDelete,fetchData,route,type}) {
  return (
    <>
        <div className="modal-overlay">
            <div className="modal-content">
                <div className="modal-header">
                    <h3>Confirm Deletion</h3>
                    <img
                        src={window.getPublicUrl('/assets/images/close.svg')}
                        onClick={() => setShowDeleteModal(false)}
                        className="close"
                        alt="Close"
                    />
                </div>
                <div className="modal-body mb-0 p-0">
                    <p>Are you sure you want to delete the {type}: <strong>{todelete?.name || todelete?.name_en}</strong>?</p>
                    <p>This action cannot be undone.</p>
                </div>
                <div className="modal-footer">
                    <button className="reset" onClick={() => setShowDeleteModal(false)}>
                        Cancel
                    </button>
                    <button
                        className="save mt-0"
                        onClick={()=>confirmDeleteData(todelete,setIsLoading,fetchData,setShowDeleteModal,settoDelete,route,type)}
                        disabled={isLoading}
                    >
                        {isLoading ? 'Deleting...' : 'Delete'}
                    </button>
                </div>
            </div>
        </div>
    </>
  )
}

export default DeleteModal